import { processRawInput } from "./processRawInput";
import ItemPlugin from "./TodoItem/TodoItem";
import userShare from "./userShare";

export default function registerTodoPlugin() {
  return { ItemPlugin, userShare, processRawInput };
}
